import { data } from '../../svg/Checklist/data';
import { makeIcon } from '../makeIcon';

export const Checklist = makeIcon(data, 'checklist', 'Checklist');

export default Checklist;
